import { Badge } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;

  width: 100%;
  padding: 75px 20px 0 250px;

  @media only screen and (max-width: 1024px) {
    padding: 70px 10px;
    display: block;
    width: 100%;
  }
`;

export const StyledButton = styled.button`
  border: 0;
  background: #1890ff;
  color: #fff;
  font-weight: bold;
  padding: 0 1.25rem;
  border-radius: 6px;
  cursor: pointer;

  :hover {
    background: #1378d6;
    transition: background-color 0.2s;
  }
`;

export const TransactionContainer = styled.main`
  width: 100%;
  flex: 1;
  min-height: 400px;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 0.8rem;
  display: flex;
  flex-direction: column;

  & > div {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const BadgeStyled = styled(Badge)`
  display: flex;
  width: 30px;
  height: 50px;
`;

export const SearchContainer = styled.div`
  flex-shrink: 0;
`;

export const SearchSummary = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  input {
    padding: 8px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    font-size: 14px;
    width: 300px;

    &:focus {
      outline: none;
      border-color: #40a9ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    &:disabled {
      background-color: #f5f5f5;
      cursor: not-allowed;
    }
  }
`;

export const TransactionTable = styled.table`
  border-collapse: collapse;
  border-spacing: 0 2px;
  width: 100%;
  border-radius: 10px;
  background: #ededed;
  padding: 0.7rem;

  thead {
    border-bottom: 1px solid #fff;
    font-weight: bold;

    td:first-child {
      border-top-left-radius: 10px;
    }
    td:last-child {
      border-top-right-radius: 10px;
    }
  }

  tbody {
    tr {
      td {
        div,
        span {
          font-weight: normal !important;
          font-size: inherit !important;
        }
      }
    }
  }

  tr:nth-child(even) {
    background: ${(props) => props.theme['gray-100']};
  }

  tr,
  td {
    padding: 5px 10px;
  }
`;

export const LevelContainer = styled.div`
  width: 100%;
  max-width: 520px;
  margin-bottom: 1rem;
  flex-shrink: 0;
`;

export const ContainerForTables = styled.div`
  display: flex;
  gap: 1rem;
  flex: 1;
  min-height: 0;

  @media (width <= 1650px) {
    display: flex;
    flex-direction: column-reverse;
  }

  & > div:first-child {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    width: 100%;
  }

  & > div:last-child {
    flex-shrink: 0;
  }

  .ant-table-row.highlighted,
  tr.highlighted {
    background-color: #fff3e0 !important;
    animation: highlightFade 2s ease-out;
  }

  @keyframes highlightFade {
    0% {
      background-color: #ff9800;
    }
    100% {
      background-color: #fff3e0;
    }
  }
`;
